import { axios } from "~/plugins/request"

export const state = () => {
    return {}
}
export const mutations = {}
export const actions = {
    findByList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanMonth/findByList`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    findById({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanMonth/findById`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },

    save({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanMonth/save`, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },



    getTitle({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(`/workPlanMonth/getTitle`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    delete({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`/workPlanMonth/delete`, params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    approval({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios.post('/workPlanMonth/approveStart', params)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      },

      callBack({ commit }, params) {
        return new Promise((resolve, reject) => {
          axios.post('/workPlanMonth/processRecallStart', params)
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      },

     







}
